import React, { useState, useEffect, useRef } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import FeeSystemMenu from "./FeeSystemMenu";
import RightsCheck from "../General/RightsCheck";

function AddAbsentFine(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  //const [DefaultSession, setDefaultSession] = useState(localStorage.getItem("DefaultSession"));

  const [showFilters, setShowFilters] = useState(true);

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [validated, setValidated] = useState(false);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [NewWingId, setNewWingId] = useState(0);
  const [NewClassId, setNewClassId] = useState(0);

  const [SessionId, setSessioinId] = useState(
    localStorage.getItem("DefaultSession")
  );
  const [SectionID, setSectionID] = useState(0);
  const [isUpdated, setIsUpdated] = useState(false);

  const [Registration_No, SetRegistrationNo] = useState("");
  const [OrderBy, setOrderBy] = useState(0);
  const [validatedPromote, setValidatedPromote] = useState(false);
  /** studentId -> leave count for fine calculation (persists across pages). */
  const [leaveCounts, setLeaveCounts] = useState({});
  const nowRef = new Date();
  const [invoiceMonth, setInvoiceMonth] = useState(nowRef.getMonth() + 1);
  const [invoiceYear, setInvoiceYear] = useState(nowRef.getFullYear());
  const [replaceMonthlyChalan, setReplaceMonthlyChalan] = useState(false);
  const [mergeExistingFeeLine, setMergeExistingFeeLine] = useState(true);

  const formRef = useRef(null);

  useEffect(() => {
    document.title = "Add Absent Fine";

    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: parseInt(UserID, 10) || 0,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SessionID: parseInt(SessionId, 10) || 0,
      Wing_Id: parseInt(NewWingId, 10) || 0,
      Class_Id: parseInt(NewClassId, 10) || 0,
      Section_Id: parseInt(SectionID, 10) || 0,
      Registration_No: Registration_No,
      OrderBy: OrderBy === 0 || OrderBy === "0" ? "Student_Name" : OrderBy,
    };

    //console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "Student/SearchStudents",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLeaveCounts({});
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [
    pageNo,
    pageSize,
    SessionId,
    NewWingId,
    NewClassId,
    SectionID,
    Registration_No,
    OrderBy,
  ]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>

            <td>{item.Student_ID}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>
              <input
                type="number"
                min={0}
                value={leaveCounts[item.Student_ID] ?? 0}
                style={{ width: "100px" }}
                className="form-control text-center"
                onChange={(e) => {
                  const v = parseInt(e.target.value, 10);
                  setLeaveCounts((prev) => ({
                    ...prev,
                    [item.Student_ID]: Number.isNaN(v) || v < 0 ? 0 : v,
                  }));
                }}
              />
            </td>
            <td>{item.SelectedClass.SelectedWing.Wing_Name}</td>
            <td>{item.SelectedClass.Class_Name}</td>
            <td>{item.SelectedSection.Section_Name}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan={10}>
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const data = {
        AccessKey: AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType,
        pageNo: pageNo,
        pageSize: pageSize,
        SessionID: parseInt(SessionId, 10) || 0,
        Wing_Id: parseInt(NewWingId, 10) || 0,
        Class_Id: parseInt(NewClassId, 10) || 0,
        Section_Id: parseInt(SectionID, 10) || 0,
        Registration_No: Registration_No,
        OrderBy: OrderBy === 0 || OrderBy === "0" ? "Student_Name" : OrderBy,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "Student/SearchStudents",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      //console.log("data", data);

      axios(api_config)
        .then(function (response) {
          //console.log(response.data);
          setLedger(response.data.ListofRecords);
          setLeaveCounts({});
          setLoading(false);
          setTotalRecords(response.data.totalRecords);
        })
        .catch(function (error) {
          //console.log(error);
        });
    }

    setValidated(true);
  };

  const handleAddFine = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const selectedValues = [];
      Object.keys(leaveCounts).forEach((k) => {
        const leaves = parseInt(leaveCounts[k], 10);
        if (!Number.isNaN(leaves) && leaves > 0) {
          selectedValues.push({ studentId: parseInt(k, 10), Leaves: leaves });
        }
      });

      if (selectedValues.length === 0) {
        toast.error("Enter leave days (greater than zero) for at least one student.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setValidatedPromote(true);
        return;
      }

      const fineRate = parseInt(form.FineRate.value, 10);
      if (!fineRate || fineRate <= 0 || Number.isNaN(fineRate)) {
        toast.error("Enter a valid fine rate per leave.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setValidatedPromote(true);
        return;
      }

      if (
        invoiceMonth < 1 ||
        invoiceMonth > 12 ||
        !invoiceYear ||
        invoiceYear < 2000 ||
        invoiceYear > 2100
      ) {
        toast.error("Select a valid challan month and year.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setValidatedPromote(true);
        return;
      }

      const data = {
        AccessKey: AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Admin",
        ListofStudentLeave: selectedValues,
        Amount: fineRate,
        InvoiceMonth: invoiceMonth,
        InvoiceYear: invoiceYear,
        ReplaceMonthlyChalanWhenAttachingOtherDues: replaceMonthlyChalan,
        MergeIntoExistingFeeLineOnChalan: mergeExistingFeeLine,
        SchoolID: 1,
      };

      axios({
        method: "post",
        url: config.base_url + "ChallanFeeSystem/AttachAbsentFineChallan",
        headers: { "Content-Type": "application/json" },
        data,
      })
        .then(function (response) {
          if (response.data.status_code == 1) {
            toast.success(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            setIsUpdated(true);
            setLeaveCounts({});
          } else {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch(function () {
          toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
        });
    }

    setValidatedPromote(true);
  };

  return (
    <>
      <RightsCheck />
      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Absent Fine
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Add Absent Fine</div>
                <p className="text-muted small mb-0 mt-1">
                  Posts to <strong>tblChalanHead</strong> and <strong>tblADLedger</strong> (fee code 003). Uses the same monthly-challan rules as other dues (bank-scroll block, optional new challan number). Does not post to <strong>tblStudentLedger</strong>.
                </p>
              </div>

              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/students/AddStudent"
                    className="button button-white button-icon"
                  >
                    Add Students
                    <i className="ri-add-fill"></i>
                  </NavLink>
                  <button
                    onClick={() => {
                      setShowFilters((prevIsActive) => !prevIsActive);
                    }}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`collapse ${showFilters ? "show" : ""} `}
          id="collapseFilteres"
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            ref={formRef}
          >
            <div className="page-content">
              <div className="container">
                <div className="card mb-2">
                  <div className="card-body p-md-4">
                    <div className="row align-items-end gy-3">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="" className="">
                            Select Session:
                          </label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setSessioinId(e.target.value);
                              setNewWingId(0);
                              setSectionID(0);
                              setNewClassId(0);
                            }}
                            name="SessionID"
                          >
                            <option value="0">---All---</option>
                            <SessionsDropDown selectedSession={SessionId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Select Wing:</label>
                          <select
                            name="Wing_Id"
                            onChange={(e) => {
                              setNewWingId(e.target.value);
                              setNewClassId(0);
                              setSectionID(0);
                            }}
                            className="form-select"
                          >
                            <option value="0">---All---</option>
                            <WingsDropDown />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="" className="">
                            Select Class:
                          </label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setNewClassId(e.target.value);
                              setSectionID(0);
                            }}
                            name="Class_ID"
                          >
                            <option value="">Please Select</option>
                            {SessionId != 0 && NewWingId != 0 && (
                              <ClassesDropDown
                                SessionID={SessionId}
                                WingID={NewWingId}
                              />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="" className="">
                            Select Section:
                          </label>
                          <select
                            className="form-select"
                            onChange={(e) => setSectionID(e.target.value)}
                            name="Section_Id"
                          >
                            <option value="0">Please Select</option>
                            {NewClassId !== 0 && (
                              <SectionDropDown ClassID={NewClassId} />
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="" className="">
                            Registration No:
                          </label>
                          <input
                            type="text"
                            name="Reg_No"
                            onChange={(e) => SetRegistrationNo(e.target.value)}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="" className="">
                            Order by:
                          </label>
                          <select
                            name="OrderBy"
                            value={OrderBy === 0 ? "Student_Name" : OrderBy}
                            onChange={(e) => setOrderBy(e.target.value)}
                            className="form-select"
                          >
                            <option value="Student_Name">Student Name</option>
                            <option value="Registration_No">Registration No</option>
                            <option value="Wing_Name">Wing Name</option>
                            <option value="Class_Name">Class</option>
                            <option value="Student_ID">Student ID Asc</option>
                            <option value="Student_ID desc">Student ID Desc</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-2 offset-md-10">
                        <div className="form-group">
                          <button
                            type="submit"
                            value="Search"
                            onClick={handleSubmit}
                            className="button button-primary w-100"
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="table_card">
                  {/* <div className="text-end mb-2 me-3">
                                    <b>{{totalRecords}} &nbsp; Records Found!</b>

                                </div> */}
                  <table className="table table-theme">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Student ID</th>
                        <th>Reg No</th>
                        <th>Name</th>
                        <th>Father Name</th>
                        <th>Total Leaves</th>
                        <th>Wing</th>
                        <th>Class</th>
                        <th>Section</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td className="text-center" colSpan={11}>
                            <Spinner animation="border" role="status"></Spinner>
                          </td>
                        </tr>
                      ) : (
                        <>{renderLedger()}</>
                      )}
                    </tbody>
                  </table>
                  {totalRecords > 10 && (
                    <div className="pagination-wrap">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label
                              className="me-2"
                              style={{ fontSize: "15px" }}
                            >
                              Page Size
                            </label>
                            <div className="form-group">
                              <select
                                className="form-select"
                                style={{ width: "100px" }}
                                value={pageSize}
                                onChange={(e) => {
                                  setPageNo(1);
                                  setPageSize(parseInt(e.target.value, 10));
                                }}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card mt-2">
              <div className="card-body">
                <div className="section-title title-sm title-left">
                  Post absent fine on monthly challan
                </div>
                <Form
                  noValidate
                  validated={validatedPromote}
                  onSubmit={handleAddFine}
                >
                  <div className="card-body p-md-4 pt-0">
                    <div className="row gy-3 align-items-end">
                      <div className="col-md-2">
                        <label className="form-label">Challan month</label>
                        <select
                          className="form-select"
                          value={invoiceMonth}
                          onChange={(e) =>
                            setInvoiceMonth(parseInt(e.target.value, 10))
                          }
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((m) => (
                            <option key={m} value={m}>
                              {m}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Challan year</label>
                        <input
                          type="number"
                          className="form-control"
                          min={2000}
                          max={2100}
                          value={invoiceYear}
                          onChange={(e) =>
                            setInvoiceYear(
                              parseInt(e.target.value, 10) ||
                                nowRef.getFullYear()
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Fine rate / leave</label>
                        <input
                          type="number"
                          name="FineRate"
                          className="form-control"
                          min={1}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="absentFineMergeFeeLine"
                            checked={mergeExistingFeeLine}
                            onChange={(e) =>
                              setMergeExistingFeeLine(e.target.checked)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="absentFineMergeFeeLine"
                          >
                            Merge into existing absent-fine line (003) on the same challan head when present.
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="absentFineReplaceChallan"
                            checked={replaceMonthlyChalan}
                            onChange={(e) =>
                              setReplaceMonthlyChalan(e.target.checked)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="absentFineReplaceChallan"
                          >
                            Issue new challan number when a monthly challan already exists: soft-delete previous head, bump sequence, clone AD lines, then add this fine.
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 ms-auto text-end">
                        <input
                          type="submit"
                          value="Attach fine (challan)"
                          className="button button-primary w-100"
                        />
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAbsentFine;
